export default __webpack_public_path__ + "db907b6070054a363301ec96dc2c586f.svg";